
import React, { useState, useEffect } from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: "https://public.readdy.ai/ai/img_res/30eebfd09b98fcd2c3366789bc57ebd5.jpg"
    },
    {
      id: 2,
      image: "https://readdy.ai/api/search-image?query=CNC%20machining%20workshop%2C%20workers%20operating%20metal%20machining%20equipment%2C%20clean%20industrial%20environment%2C%20no%20masks%2C%20realistic%20lighting%2C%20modern%20manufacturing%20facility&width=1600&height=900&seq=osgb-cnc-workshop&orientation=landscape"
    },
    {
      id: 3,
      image: "https://readdy.ai/api/search-image?query=logistics%20warehouse%20with%20supervisors%20and%20forklift%2C%20coordinated%20safety%20environment%2C%20no%20masks%2C%20realistic%20clarity%2C%20organized%20storage%20facility%2C%20professional%20warehouse&width=1600&height=900&seq=osgb-warehouse-logistics&orientation=landscape"
    }
  ];

  // Auto slide change - 7 seconds
  useEffect(() => {
    const slideTimer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 7000);

    return () => clearInterval(slideTimer);
  }, []);

  return (
    <section className="relative w-full h-[80vh] flex items-center justify-center overflow-hidden">
      {/* Background Images with Soft Fade Transition */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            backgroundImage: `url('${slide.image}')`
          }}
        />
      ))}

      {/* Gradient Overlay - More transparent after first line */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.3) 100%)'
        }}
      />

      {/* Static Content - No animations on slide change */}
      <div className="container mx-auto px-4 text-center text-white w-full relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Static Title - 2 lines with green "Profesyonel Destek" */}
          <h1 
            className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight animate-fade-in-up" 
            style={{ fontFamily: 'Montserrat, sans-serif', animationDuration: '350ms' }}
          >
            İş Güvenliğinde<br />
            <span className="text-[#3AC76A]">Profesyonel Destek</span>
          </h1>

          {/* Added Image with Delayed Animation */}
          <div className="mb-8 flex justify-center">
            <img 
              src="https://static.readdy.ai/image/2b1409af55cbbc24ae624602859a344f/36d78825f277b9144a8d80f315db05ba.png"
              alt="İş Güvenliği Profesyonel Destek"
              className="max-w-md w-full h-auto opacity-0 animate-fade-in-delayed"
              style={{
                animationDelay: '800ms',
                animationDuration: '1000ms',
                animationFillMode: 'forwards'
              }}
            />
          </div>

          {/* Static Subtitle */}
          <h3 
            className="text-xl md:text-2xl mb-8 text-gray-100 font-medium animate-fade-in-up"
            style={{ 
              fontFamily: 'Source Sans Pro, sans-serif', 
              animationDuration: '350ms',
              animationDelay: '100ms'
            }}
          >
            Çalışan sağlığını koruyan, kazaları önleyen ve yasal uyumu sağlayan çözümler sunuyoruz.
          </h3>

          {/* Static Buttons */}
          <div 
            className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up"
            style={{ 
              animationDuration: '350ms',
              animationDelay: '200ms'
            }}
          >
            <Button 
              variant="primary" 
              size="lg" 
              href="/hizmetler" 
              className="bg-[#3AC76A] hover:bg-[#3AC76A]/90 border-0 transition-opacity duration-300"
            >
              <i className="ri-shield-check-line mr-2"></i>
              Hizmetlerimiz
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              href="/iletisim" 
              className="border-2 border-white text-white hover:bg-white/10 transition-all duration-300"
            >
              <i className="ri-file-text-line mr-2"></i>
              Ücretsiz Teklif Al
            </Button>
          </div>

          {/* Service Cards */}
          <div 
            className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center animate-fade-in-up"
            style={{ 
              animationDuration: '350ms',
              animationDelay: '300ms'
            }}
          >
            <div className="bg-white/15 backdrop-blur-sm rounded-lg p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="w-16 h-16 bg-[#3AC76A] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-shield-star-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>Uzman Kadro</h3>
              <p className="text-sm text-gray-200" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Deneyimli İş Güvenliği Uzmanlarımızla güvenliğinizi sağlıyoruz</p>
            </div>
            <div className="bg-white/15 backdrop-blur-sm rounded-lg p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="w-16 h-16 bg-[#3AC76A] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>Sürekli Destek</h3>
              <p className="text-sm text-gray-200" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Acil durumlarda yanınızdayız, kesintisiz hizmet</p>
            </div>
            <div className="bg-white/15 backdrop-blur-sm rounded-lg p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="w-16 h-16 bg-[#3AC76A] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-award-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>Sertifikalı Hizmet</h3>
              <p className="text-sm text-gray-200" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Çalışma ve Sosyal Güvenlik Bakanlığı tarafından akredite Osgb Hizmetleri</p>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-[#3AC76A] scale-125' : 'bg-white/50 hover:bg-white/70'
            }`}
          />
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 right-8">
        <i className="ri-arrow-down-line text-[#3AC76A] text-2xl"></i>
      </div>
    </section>
  );
};
